"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.members = void 0;
const functions_1 = require("firebase/functions");
exports.members = (0, functions_1.httpsCallable)((0, functions_1.getFunctions)(), "artist-members");
//# sourceMappingURL=members.js.map